<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
     <a-spin :spinning="confirmLoading">
        <detail-list :col="1" size="small">
          <detail-list-item :term="$t('命令标识')">{{model.commandId}}</detail-list-item>
        </detail-list>
        <detail-list size="small">
          <detail-list-item :term="$t('命令类型')">{{$t(commandNameList[model.cmd])}}</detail-list-item>
          <detail-list-item :term="$t('表类型')">{{$t(meterTypeObj[model.meterType])}}</detail-list-item>
          <!--<detail-list-item term="指令标记帧">{{model.mid}}</detail-list-item>-->
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('状态')">{{$t(reportStatusObj[model.status])}}</detail-list-item>
          <detail-list-item :term="$t('发送时间')">{{model.sendTime}}</detail-list-item>
          <detail-list-item :term="$t('回应时间')">{{model.receiveTime}}</detail-list-item>
        </detail-list>
        <a-form :colon="colon">
          <a-row :gutter="24">
            <a-col :span="24" class="descriptions">
              <a-descriptions v-if="model.cmd == 0" :title="$t('命令参数')" bordered size="small">
                  <template v-for="(val,key) in formateCmdParamObj">
                      <a-descriptions-item v-if="formateCmdParamObj[key]&&termIdParams[key]" :label="$t(termIdParams[key])" :key="key">
                        {{val}}
                      </a-descriptions-item>
                  </template>
              </a-descriptions>
              <a-descriptions v-else-if="model.cmd == 3" :title="$t('命令参数')" bordered size="small">
                  <!--历史日结信息-->
                  <a-descriptions-item :label="$t('开始时间')">
                    {{formateCmdParamObj.startDate}}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('记录条数')">
                    {{formateCmdParamObj.recordNum}}
                  </a-descriptions-item>
              </a-descriptions>
              <a-descriptions v-else-if="['4','5','6'].includes(model.cmd)" :title="$t('命令参数')" bordered size="small">
                  <!--4阀门动作记录,5联网失败记录,6故障记录-->
                  <a-descriptions-item :label="$t('起始条数')">
                    {{formateCmdParamObj.startNo}}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('记录条数')">
                    {{formateCmdParamObj.recordNum}}
                  </a-descriptions-item>
              </a-descriptions>
              <a-descriptions v-else-if="model.cmd == 10" :title="$t('命令参数')" bordered size="small">
                  <!--充值命令-->
                    <a-descriptions-item :label="$t('充值时间')">
                      {{formateCmdParamObj.payNum}}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('充值次数')">
                      {{formateCmdParamObj.payTimes}}
                    </a-descriptions-item>
              </a-descriptions>
              <a-form-item v-else  :label="$t('命令参数')">
                <a-textarea :readOnly="disableSubmit" :placeholder="$t('请输入命令参数')" v-model="model.cmdParam" />
              </a-form-item>
              
            </a-col>
            <!--
            <a-col :span="24">
              <a-form-item  label="命令内容">
                <a-textarea :readOnly="disableSubmit" placeholder="请输入命令内容" v-model="model.cmdContent" />
              </a-form-item>
            </a-col>
            -->
            <!--
            <a-col :span="24">
              <a-form-item  label="接收内容">
                <a-textarea :readOnly="disableSubmit" placeholder="请输入接收内容" v-model="model.receiveContent" />
              </a-form-item>
            </a-col>
            -->
            <!-- 0: '终端参数设置',1: '查询终端参数',2: '查询基础信息',3: '历史日结信息查询',4: '阀门动作记录查询',
              5: '联网失败记录',6: '终端故障记录',17: '开阀',18: '关阀',19: '取消阀控'-->
            <a-col :span="24" class="descriptions" v-if="model.cmd == 0">
              <a-descriptions v-if="formateRemarkObj.tag9&&formateRemarkObj.tag9.dataIdList" :title="$t('命令结果')" bordered size="small">
                  <template v-for="(val,index) in formateRemarkObj.tag9.dataIdList">
                      <a-descriptions-item v-if="val&&termIdParams[val]" :label="$t(termIdParams[val])" :key="val">
                        {{$t(resultCodeObj[(formateRemarkObj.tag9.dataIdResult)[index]])}}
                      </a-descriptions-item>
                  </template>
              </a-descriptions>
            </a-col>
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '1'">
              <a-descriptions :title="$t('命令回应内容')" bordered size="small" :column="3" v-if="formateRemarkObj.tag3">
                <!--
                <a-descriptions-item label="过流告警阈值(L/h)">{{formateRemarkObj.tag3.overFlowWarningThreshold}}</a-descriptions-item>
                <a-descriptions-item label="持续过流告警时间(分钟)">{{formateRemarkObj.tag3.overFlowWarningTime}}</a-descriptions-item>
                <a-descriptions-item label="反流告警阈值(L/h)">{{formateRemarkObj.tag3.reserveFlowWarningThreshold}}</a-descriptions-item>
                <a-descriptions-item label="持续反流告警时间(分钟)">{{formateRemarkObj.tag3.reserveFlowWarningTime}}</a-descriptions-item>
                <a-descriptions-item label="即时告警ID">{{formateRemarkObj.tag3.realTimeWarningId}}</a-descriptions-item>
                -->
                <a-descriptions-item :label="$t('IP地址')">{{formateRemarkObj.tag3.ipStr}}</a-descriptions-item>
                <a-descriptions-item :label="$t('端口号')">{{formateRemarkObj.tag3.port}}</a-descriptions-item>
                <a-descriptions-item label="APN" :span="2">{{formateRemarkObj.tag3.strAPN}}</a-descriptions-item>
                <a-descriptions-item :label="$t('定时上报离散起始时间')">{{formateRemarkObj.tag3.fixedTimeReportStart}}</a-descriptions-item>
                <a-descriptions-item :label="$t('定时上报离散结束时间')">{{formateRemarkObj.tag3.fixedTimeReportEnd}}</a-descriptions-item>
                <a-descriptions-item :label="$t('定时上报离散估长(秒)')">{{formateRemarkObj.tag3.fixedTimeReportPeriod}}</a-descriptions-item>
                <a-descriptions-item :label="$t('定时上报频率')">{{formateRemarkObj.tag3.fixedTimeReportValue}}{{formateRemarkObj.tag3.fixedTimeReportCycle}}</a-descriptions-item>
                <a-descriptions-item :label="$t('重传次数')">{{formateRemarkObj.tag3.retryReportCount}}</a-descriptions-item>
                <a-descriptions-item :label="$t('重传间隔(秒)')">{{formateRemarkObj.tag3.retryReportPeriod}}</a-descriptions-item>
                <a-descriptions-item :label="$t('最大失联次数阈值')">{{formateRemarkObj.tag3.maxAllowReportFailedCount==255?$t('不启用'):formateRemarkObj.tag3.maxAllowReportFailedCount}}</a-descriptions-item>
                <a-descriptions-item :label="$t('最大激活上报次数')">{{formateRemarkObj.tag3.maxActiveReportCountOneDay==255?$t('不启用'): formateRemarkObj.tag3.maxActiveReportCountOneDay}}</a-descriptions-item>
                <a-descriptions-item :label="$t('电压告警阈值1(V)')">{{formateRemarkObj.tag3.voltageWarning1?formateRemarkObj.tag3.voltageWarning1/1000:''}}</a-descriptions-item>
                <a-descriptions-item :label="$t('电压告警阈值2(V)')">{{formateRemarkObj.tag3.voltageWarning2?formateRemarkObj.tag3.voltageWarning2/1000:''}}</a-descriptions-item>
                <a-descriptions-item :label="$t('计费窗口1起始时间')">{{formateRemarkObj.tag3.closeSampleStart}}</a-descriptions-item>
                <a-descriptions-item :label="$t('计费窗口1结束时间')">{{formateRemarkObj.tag3.closeSampleEnd}}</a-descriptions-item>
                
                <a-descriptions-item :label="$t('计费窗口2起始时间')">{{formateRemarkObj.tag3.closeSampleStart2}}</a-descriptions-item>
                <a-descriptions-item :label="$t('计费窗口2结束时间')">{{formateRemarkObj.tag3.closeSampleEnd2}}</a-descriptions-item>
                <!--
                    <a-descriptions-item label="密集采样时间间隔(分钟)">{{formateRemarkObj.tag3.closeSamplePeriod}}</a-descriptions-item>
                <a-descriptions-item label="密集采样天数">{{formateRemarkObj.tag3.closeSampleDays}}</a-descriptions-item>
                <a-descriptions-item label="密集采样数据格式">{{formateRemarkObj.tag3.closeDataFormat==0?'两字节':formateRemarkObj.tag3.closeDataFormat==1?'四字节(包含正向流量和逆向流量)': '--'}}</a-descriptions-item>
                <a-descriptions-item label="间隔流量时间间隔(分钟)">{{formateRemarkObj.tag3.intervalDataTimePeriod}}</a-descriptions-item>
                <a-descriptions-item label="间隔流量数据格式">{{formateRemarkObj.tag3.intervalDataFormat==0?'四字节':formateRemarkObj.tag3.intervalDataFormat==1?'八字节(包含正向流量和逆向流量)': '--'}}</a-descriptions-item>
                -->
                <a-descriptions-item :label="$t('阀门堵转是否开启')">{{formateRemarkObj.tag3.hasValveCtrl==null?'':formateRemarkObj.tag3.hasValveCtrl==0?$t('不开启'):$t('开启')}}</a-descriptions-item>
                <a-descriptions-item :label="$t('阀门开关指令')">{{$t(fkOpenAndCloseObj[formateRemarkObj.tag3.valveCtrlCommand])}}</a-descriptions-item>
                <a-descriptions-item :label="$t('阀门到位超时时间(秒)')">{{formateRemarkObj.tag3.valveCtrlTimeOut}}</a-descriptions-item>
                <a-descriptions-item :label="$t('缺电关阀时间(分钟)')">{{formateRemarkObj.tag3.voltageLowCloseValveTime==null?'':formateRemarkObj.tag3.voltageLowCloseValveTime == 65535?$t('缺电不关阀'):formateRemarkObj.tag3.voltageLowCloseValveTime}}</a-descriptions-item>
                <a-descriptions-item :label="$t('阀门开度')">{{formateRemarkObj.tag3.openValveNum}}</a-descriptions-item>
                <!--
                <a-descriptions-item label="干扰关阀时间(分钟)">{{formateRemarkObj.tag3.interferenceCloseValveTime == 65535?'干扰不关阀':formateRemarkObj.tag3.interferenceCloseValveTime}}</a-descriptions-item>
                -->
                <a-descriptions-item :label="$t('NB加密使能')">{{formateRemarkObj.tag3.encryption|transEnableFilter}}</a-descriptions-item>
                <a-descriptions-item :label="$t('数据清除')">{{$t(clearnCodeObj[formateRemarkObj.tag3.dataClear])}}</a-descriptions-item>
                <!--
                <a-descriptions-item label="表底数(L)">{{formateRemarkObj.tag3.meterBaseNum}}</a-descriptions-item>
                <a-descriptions-item label="脉冲系数">{{wareObj[formateRemarkObj.tag3.pulseFactor]}}L</a-descriptions-item>
                -->
                <a-descriptions-item :label="$t('水表表号')">{{formateRemarkObj.tag3.meterId}}</a-descriptions-item>
                <a-descriptions-item :label="$t('自定义校时')">{{formateRemarkObj.tag3.adjustTimeDIY}}</a-descriptions-item>
                <a-descriptions-item :label="$t('日结数据组数')">{{formateRemarkObj.tag3.daySumUseCount}}</a-descriptions-item>
                <!--
                <a-descriptions-item label="日结累计流量格式">{{formateRemarkObj.tag3.daySumUseFormat}}</a-descriptions-item>-->
                <!--
                <a-descriptions-item label="表端计费类型">{{formateRemarkObj.tag3.meterCalFeeFlag == 1?'表端计费': '表端不计费'}}</a-descriptions-item>
                -->
                <a-descriptions-item :label="$t('充值次数')">{{formateRemarkObj.tag3.payTimes}}</a-descriptions-item>
                <!--
                <a-descriptions-item label="工作模式">{{formateRemarkObj.tag3.meterWorkModel == 1?'用户模式': '调试模式'}}</a-descriptions-item>
                
                <a-descriptions-item label="压力采集时间间隔">{{formateRemarkObj.tag3.pressureSampleTimePeriod}}</a-descriptions-item>
                <a-descriptions-item label="压力采集起始时间">{{formateRemarkObj.tag3.pressureSampleStartTime}}</a-descriptions-item>
                <a-descriptions-item label="压力采集组数">{{formateRemarkObj.tag3.pressureSampleCount}}</a-descriptions-item>
                <a-descriptions-item label="压力数据指示">{{formateRemarkObj.tag3.pressureDataFormat}}</a-descriptions-item>
                <a-descriptions-item label="压力报警灵敏度">{{formateRemarkObj.tag3.pressureWarningSensitivity}}</a-descriptions-item>
                <a-descriptions-item label="压力报警上限(MPa)">{{formateRemarkObj.tag3.pressureWarningTop/100}}</a-descriptions-item>
                <a-descriptions-item label="压力报警下限(MPa)">{{formateRemarkObj.tag3.pressureWarningLow/100}}</a-descriptions-item>
                <a-descriptions-item label="温度采集时间间隔">{{formateRemarkObj.tag3.tempSampleTimePeriod}}</a-descriptions-item>
                <a-descriptions-item label="温度采集起始时间">{{formateRemarkObj.tag3.tempSampleStartTime}}</a-descriptions-item>
                <a-descriptions-item label="温度采集组数">{{formateRemarkObj.tag3.tempSampleCount}}</a-descriptions-item>
                <a-descriptions-item label="温度数据指示">{{formateRemarkObj.tag3.tempDataFormat}}</a-descriptions-item>
                <a-descriptions-item label="温度报警灵敏度">{{formateRemarkObj.tag3.tempWarningSensitivity}}</a-descriptions-item>
                <a-descriptions-item label="温度报警上限(℃)">{{formateRemarkObj.tag3.tempWarningTop/100}}</a-descriptions-item>
                <a-descriptions-item label="温度报警下限(℃)">{{formateRemarkObj.tag3.tempWarningLow/100}}</a-descriptions-item>
                -->
                <a-descriptions-item :label="$t('剩余天数报警阀控使能')">{{formateRemarkObj.tag3.feeCtrlFlag==null?'':formateRemarkObj.tag3.feeCtrlFlag==1?$t('使能'):$t('不使能')}}</a-descriptions-item>
                <a-descriptions-item :label="$t('自动校时')">{{$t(timeObj[formateRemarkObj.tag3.adjustTimeWay])}}</a-descriptions-item>
                <a-descriptions-item :label="$t('报警剩余时间(分钟)')">{{formateRemarkObj.tag3.warningFee}}</a-descriptions-item>
                <a-descriptions-item :label="$t('允许透支时间(分钟)')">{{formateRemarkObj.tag3.overdraftFee}}</a-descriptions-item>
                <a-descriptions-item :label="$t('阀门维护')">{{formateRemarkObj.tag3.valveMaintenance==null?'':formateRemarkObj.tag3.valveMaintenance ==1?$t('启用'): $t('不启用')}}</a-descriptions-item>
                <a-descriptions-item :label="$t('红外加密使能')">{{formateRemarkObj.tag3.infraredEncryptionEnable |transEnableFilter}}</a-descriptions-item>
                <a-descriptions-item :label="$t('刷卡上报使能')">{{formateRemarkObj.tag3.cardUpEnable |transEnableFilter}}</a-descriptions-item>
                <a-descriptions-item :label="$t('上电上报使能')">{{formateRemarkObj.tag3.powerUpEnable |transEnableFilter}}</a-descriptions-item>
                <a-descriptions-item :label="$t('计费结束关阀使能')">{{formateRemarkObj.tag3.calEndFkEnable|transEnableFilter}}</a-descriptions-item>

              </a-descriptions>
            </a-col>
            <!--查询基础信息-->
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '2'">
              <a-descriptions :title="$t('命令回应内容')" bordered size="small" v-if="formateRemarkObj.tag1">
                <a-descriptions-item :label="$t('SIM卡号')">
                  {{formateRemarkObj.tag1.iccid}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('IMSI号')">
                  {{formateRemarkObj.tag1.imsi}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('终端运行时间')">
                  {{formateRemarkObj.tag1.meterRunDays}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('终端软件版本')">
                  {{formateRemarkObj.tag1.meterSoftVer}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('程序序列号')">
                  {{formateRemarkObj.tag1.meterSerialNum}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('模组号')">
                  {{formateRemarkObj.tag1.imei}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('模组版本号')">
                  {{formateRemarkObj.tag1.modelVersion}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('产品型号')">
                  {{formateRemarkObj.tag1.productVersion}}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('表编号')">
                  {{formateRemarkObj.tag1.meterId}}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <!--历史日结信息查询-->
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '3'">
              <a-descriptions :title="$t('命令回应内容')" bordered size="small" v-if="formateRemarkObj.tag21&&formateRemarkObj.tag21.positiveSumFlow">
                <a-descriptions-item v-for="(item,index) in formateRemarkObj.tag21.positiveSumFlow" :label="$t('记录值')+(index+1)" :key="index">
                  {{item>-1?item: $t('无记录')}}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <!--阀门动作记录查询-->
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '4'">
              <a-descriptions :title="$t('命令回应内容')" bordered size="small" v-if="formateRemarkObj.tag22&&formateRemarkObj.tag22.dateList">
                <template v-for="(item,index) in formateRemarkObj.tag22.dateList">
                  <a-descriptions-item  :label="$t('阀门动作时间')" :key="item">
                    {{parseInt(item)==0?$t('无记录'): item}}
                  </a-descriptions-item>
                  <a-descriptions-item  :label="$t('阀门动作状态')" :key="item">
                    {{formateRemarkObj.tag22.stateList[index] == 255?$t('无记录'): fkStatusObj[formateRemarkObj.tag22.stateList[index]]}}
                  </a-descriptions-item>
                  <a-descriptions-item  :label="$t('阀门动作原因')" :key="item">
                    {{formateRemarkObj.tag22.reasonList[index] == 255?$t('无记录'):fkActiveObj[formateRemarkObj.tag22.reasonList[index]]}}
                  </a-descriptions-item>
                </template>
              </a-descriptions>
            </a-col>
            <!--联网失败记录查询-->
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '5'">
              <a-descriptions :column="2" :title="$t('命令回应内容')" bordered size="small" v-if="formateRemarkObj.tag23&&formateRemarkObj.tag23.dateList">
                <template v-for="(item,index) in formateRemarkObj.tag23.dateList">
                  <a-descriptions-item  :label="$t('联网失败时间')" :key="item">
                    {{parseInt(item)==0?$t('无记录'): item}}
                  </a-descriptions-item>
                  <a-descriptions-item  :label="$t('联网失败原因')" :key="item">
                    {{formateRemarkObj.tag23.reasonList[index] == 255?$t('无记录'):formateRemarkObj.tag23.reasonList[index]}}
                  </a-descriptions-item>
                </template>
              </a-descriptions>
            </a-col>
            <!--终端故障查询-->
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '6'">
              <a-descriptions :title="$t('命令回应内容')" bordered size="small" v-if="formateRemarkObj.tag24&&formateRemarkObj.tag24.dateList">
                <template v-for="(item,index) in formateRemarkObj.tag24.dateList">
                  <a-descriptions-item :label="$t('故障产生时间')" :key="item">
                    {{parseInt(item)==0?$t('无记录'): item}}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('故障类型')" :key="item">
                    {{formateRemarkObj.tag24.typeList[index] == 255?$t('无记录'):faultTypeObj[formateRemarkObj.tag24.typeList[index]]}}
                  </a-descriptions-item>
                  <a-descriptions-item  :label="$t('故障持续时间')" :key="item">
                    {{formateRemarkObj.tag24.faultTimeList[index] == 0?$t('无记录'): formateRemarkObj.tag24.faultTimeList[index]}}
                  </a-descriptions-item>
                </template>
              </a-descriptions>
            </a-col>
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '7'">
              <a-descriptions :title="$t('命令回应内容')" bordered size="small" :column="3" v-if="formateRemarkObj.tag2">
                <a-descriptions-item :label="$t('进水温度(℃)')">{{formateRemarkObj.tag2.innerTep}}</a-descriptions-item>
                <a-descriptions-item :label="$t('出水温度(℃)')">{{formateRemarkObj.tag2.outerTep}}</a-descriptions-item>
                <a-descriptions-item :label="$t('电池电压(mv)')">{{formateRemarkObj.tag2.voltage}}</a-descriptions-item>
                <a-descriptions-item :label="$t('累计发送成功次数')">{{formateRemarkObj.tag2.sumSuccessCount}}</a-descriptions-item>
                <a-descriptions-item :label="$t('累计发送失败次数')">{{formateRemarkObj.tag2.sumFailedCount}}</a-descriptions-item>
                <a-descriptions-item :label="$t('状态字信息')">ST1:{{formateRemarkObj.tag2.status1}}ST2:{{formateRemarkObj.tag2.status2}}ST3:{{formateRemarkObj.tag2.status3}}ST4:{{formateRemarkObj.tag2.status4}}</a-descriptions-item>
                <a-descriptions-item :label="$t('当前累计开阀时间(分钟)')">{{formateRemarkObj.tag2.sumFlow}}</a-descriptions-item>
                <a-descriptions-item :label="$t('内部温度(℃)')">{{formateRemarkObj.tag2.innerTemp}}</a-descriptions-item>
                <a-descriptions-item :label="$t('终端时钟')">{{formateRemarkObj.tag2.meterTime}}</a-descriptions-item>
                <a-descriptions-item :label="$t('定时上报频率')">{{formateRemarkObj.tag2.reportValue}}{{formateRemarkObj.tag2.reportCycle}}</a-descriptions-item>
                <a-descriptions-item :label="$t('当前剩余开阀时间(分钟)')">{{formateRemarkObj.tag2.remainN}}</a-descriptions-item>
                <a-descriptions-item label="CSQ">{{formateRemarkObj.tag2.csq}}</a-descriptions-item>
                <a-descriptions-item :label="$t('充值次数')">{{formateRemarkObj.tag2.payTimes}}</a-descriptions-item>
                <a-descriptions-item :label="$t('累计通讯耗时(s)')">{{formateRemarkObj.tag2.sumConnectNetTime}}</a-descriptions-item>
                <a-descriptions-item :label="$t('表号')">{{formateRemarkObj.tag2.meterId}}</a-descriptions-item>
                <!--
                <a-descriptions-item label="报警金额(元)">{{formateRemarkObj.tag2.meterWarnMoney}}</a-descriptions-item>
                -->
              </a-descriptions>
            </a-col>
            <a-col :span="24" class="descriptions" v-else-if="model.cmd === '10'">
              <a-descriptions :title="$t('命令回应内容')" bordered size="small">
                    <!--充值命令-->
                    <a-descriptions-item :label="$t('充值结果')">
                      {{formateRemarkObj.tag12.result|transResulrFilter}}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('充值时间')">
                      {{formateRemarkObj.tag12.payNum}}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('充值次数')">
                      {{formateRemarkObj.tag12.payTimes}}
                    </a-descriptions-item>
                </a-descriptions>
            </a-col>
          </a-row>
        </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
  import {getNextDate} from '@/utils/util'
  import i18n from '@/i18n'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {isNull, isUndefinedAndNull,isUndefined} from '@/utils/validate'
  import {fkActiveObj,fkStatusObj,netFailReasonObj,faultTypeObj,dataFlagObj,reportStatusObj} from '@/utils/constants/protocolNthConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  const termIdParams = {
    0: '进水温度突变阀值',
    1: '出水温度突变阀值',
    2: '测温周期',
    3: '进水温度校准系数',
    4: '回水温度校准系数',
    5: '服务器地址',
    6: 'APN',
    7: '定时上报信息',
    8: '定时上报频率',
    9: '重传次数',
    10: '重传间隔',
    11: '最大失联次数阈值',
    12: '最大激活上报次数',
    13: '电压告警阈值',
    14: '计费窗口',
    15: '密集采样天数',
    16: '密集采样数据格式',
    17: '间隔流量时间间隔',
    18: '间隔流量数据格式',
    19: '阀门堵转使能',
    20: '阀门操控指令',
    21: '阀门到位超时时间',
    22: '缺电关阀时间',
    23: '阀门开度',
    24: '干扰关阀时间',
    25: 'NB加密使能',
    27: '数据清除',
    28: '表底数',
    29: '脉冲系数',
    30: '表号',
    31: '自定义校时',
    33: '日结数据组数',
    35: '充值次数',
    /*
    34: '表端计费模式',
    38: '工作模式',
    40: '压力采集时间间隔',
    41: '压力采样起始时间',
    42: '压力采集组数',
    43: '压力数据指示',
    44: '压力报警灵敏度',
    45: '压力报警上限',
    46: '压力报警下限',
    48: '温度采样时间间隔',
    49: '温度采样起始时间',
    50: '温度采样组数',
    51: '温度数据指示',
    52: '温度报警灵敏度',
    53: '温度报警上限',
    54: '温度报警下限',
    */
    58: '剩余天数报警阀控使能',
    59: '校时方式',
    60: '报警剩余时间',
    61: '允许透支时间',
    62: '阀门维护功能',
    63: '红外加密使能',
    64: '刷卡上报使能',
    65: '上电上报使能',
    66: '计费结束关阀使能'
  }
  const dayRecordIndexCodeObj = {
        0: '日结累计流量两字节',
        1: '日结累计流量四字节',
        16: '日结累计正流量和日结累计负流量两字节',
        17: '日结累计正流量和日结累计负流量四字节',
        32: '日用量两字节',
        33: '日用量四字节'
  }
  
  export default {
    name: "PartCommandModal",
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:this.$t("操作"),
        meterTypeObj,
        disableSubmit: false,
        visible: false,
        colon: false,
        model: {},
        positiveSumFlow:'',
        formateRemarkobj: {
          daySumFlowList:[],// 日结累计流量
        },
        confirmLoading: false,
        validatorRules:{
        },
        url: {
          add: "/model/partCommand/add",
          edit: "/model/partCommand/edit",
        },
        commandNameList: dataFlagObj,
        formateRemarkObj: {},
        formateCmdParamObj: {},
        termIdParams,
        timeObj: {0: '不启用',1: 'AT指令校时',2: '运营商平台校时'},
        fkObj: {0: '无阀',1: '阀门堵转功能不启用',3: '阀门堵转功能启用'},
        fkOpenAndCloseObj: {0: '阀门关闭(强制)',1: '阀门开启(强制)',2: '取消阀控',3: '关阀',4: '开阀'},
        fkFeeCtrlObj: {0: '报警不关阀、透支不关阀',1: '报警关阀、透支不关阀',2: '报警不关阀、透支关阀',3: '报警关阀、透支关阀'},
        wareObj: {0: '1L',1: '10L',2: '100L',3: '1000L'},
        clearnCodeObj: {
          0: '不执行',
          1: '清除故障',
          2: '清除外接EEPROM内的数据',
          3: '清除表端数据'
        },
        fkOpenCloseCodeObj: {
          0: '阀门关闭',
          1: '阀门开启',
          2: '取消阀控'
        },
        unitCodeObj: {
          10: '分',
          20: '时',
          30: '天',
          40: '周',
          50: '月'
        },
        resultCodeObj: {
          0: '处理成功',
          1: '消息有误',
          2: '不支持',
          3: '处理失败'
        },
        dayRecordIndexCodeObj,
        fkStatusObj,
        fkActiveObj,
        netFailReasonObj,
        faultTypeObj,
        reportStatusObj,
        bodyStyle: {
          height: '70vh',
          'overflow-y': 'scroll'
        }
      }
    },
    filters: {
      transEnableFilter(flag) {
        if(flag === null||flag==''){
          return '';
        }
        if(flag == 0) {
          return i18n.t('不使能');
        }else if(flag == 1) {
          return i18n.t('使能');
        }else{
          return i18n.t('未知');
        }
        
      },
      transResulrFilter(flag) {
        if(flag === null||flag==''){
          return '';
        }
        let obj = {0:i18n.t('处理成功'),1:i18n.t('消息有误'),2:i18n.t('不支持'),3:i18n.t('处理失败')}
        if(isUndefined(obj[flag])) {
          return i18n.t('未知');
        }
        return obj[flag];
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        console.log(this.model);
        this.visible = true;
        if(!isUndefinedAndNull(this.model.remark)) {
          this.formateRemarkObj = JSON.parse(this.model.remark)
          console.log(this.formateRemarkObj.tag2);
          console.log(this.model.remark)
        }
        this.formateRemark(this.model.remark)
        
        if(!isUndefinedAndNull(this.model.cmdParam)&&this.model.cmd == 0) {
          this.formateCmdParamObj = {...JSON.parse(this.model.cmdParam)}
          if(this.formateCmdParamObj[63]) {
            this.formateCmdParamObj[63] = this.formateCmdParamObj[63] == 1?this.$t('使能'): this.$t('不使能')
          }
          if(this.formateCmdParamObj[62]) {
            this.formateCmdParamObj[62] = this.formateCmdParamObj[62] == 1?this.$t('启用'): this.$t('不启用')
          }
          if(this.formateCmdParamObj[61]) {
            this.formateCmdParamObj[61] = this.formateCmdParamObj[61]+this.$t('元')
          }
          if(this.formateCmdParamObj[60]) {
            this.formateCmdParamObj[60] = this.formateCmdParamObj[60]+this.$t('元')
          }
          if(this.formateCmdParamObj[59]) {
            this.formateCmdParamObj[59] = this.$t(this.timeObj[this.formateCmdParamObj[59]])
          }
          if(this.formateCmdParamObj[58]) {
            this.formateCmdParamObj[58] = this.$t(this.fkFeeCtrlObj[this.formateCmdParamObj[58]])
          }
          if(this.formateCmdParamObj[54]) {
            this.formateCmdParamObj[54] = this.formateCmdParamObj[54]/100+'℃'
          }
          if(this.formateCmdParamObj[53]) {
            this.formateCmdParamObj[53] = this.formateCmdParamObj[53]/100+'℃'
          }
          if(this.formateCmdParamObj[46]) {
            this.formateCmdParamObj[46] = this.formateCmdParamObj[46]/1000+'MPa'
          }
          if(this.formateCmdParamObj[45]) {
            this.formateCmdParamObj[45] = this.formateCmdParamObj[45]/1000+'MPa'
          }
          if(this.formateCmdParamObj[40]) {
            this.formateCmdParamObj[40] = this.formateCmdParamObj[40] == 255?this.$t('不启用'):this.formateCmdParamObj[40]
          }
          if(this.formateCmdParamObj[38]) {
            this.formateCmdParamObj[38] = this.formateCmdParamObj[38] == 1?this.$t('用户模式'): this.$t('调试模式')
          }
           if(this.formateCmdParamObj[35]) {
            this.formateCmdParamObj[35] = this.formateCmdParamObj[35]+this.$t('次')
          }
          if(this.formateCmdParamObj[34]) {
            this.formateCmdParamObj[34] = this.formateCmdParamObj[34]== 1?this.$t('表端计费'): this.$t('表端不计费')
          }
          if(this.formateCmdParamObj[33]) {
            let arr = this.formateCmdParamObj[33].split(',')
            this.formateCmdParamObj[33] = this.$t('日结数据组数: ')+arr[0]+this.$t(',日结数据指示: ')+this.$t(this.dayRecordIndexCodeObj[arr[1]])
          }
          if(this.formateCmdParamObj[30]) {
            this.formateCmdParamObj[30] = this.formateCmdParamObj[30].split(',').join('')
          }
          if(this.formateCmdParamObj[29]) {
            this.formateCmdParamObj[29] = this.$t(this.wareObj[this.formateCmdParamObj[29]])
          }
          if(this.formateCmdParamObj[28]) {
            this.formateCmdParamObj[28] = this.formateCmdParamObj[28]+'L'
          }
          if(this.formateCmdParamObj[27]) {
            this.formateCmdParamObj[27] = this.$t(this.clearnCodeObj[this.formateCmdParamObj[27]])
          }
          if(this.formateCmdParamObj[25]) {
            this.formateCmdParamObj[25] = this.formateCmdParamObj[25] == 1?this.$t('使能'): this.$t('不使能')
          }
          if(this.formateCmdParamObj[24]) {
            this.formateCmdParamObj[24] = this.formateCmdParamObj[24] == 65535?this.$t('干扰不关阀'):this.formateCmdParamObj[24]+this.$t('分钟')
          }
          if(this.formateCmdParamObj[23]) {
            this.formateCmdParamObj[23] = this.formateCmdParamObj[23] +this.$t('分钟')
          }
          if(this.formateCmdParamObj[22]) {
            this.formateCmdParamObj[22] = this.formateCmdParamObj[22] == 65535?this.$t('缺电不关阀'): this.formateCmdParamObj[22]+this.$t('分钟')
          }
          if(this.formateCmdParamObj[21]) {
            this.formateCmdParamObj[21] = this.formateCmdParamObj[21]+this.$t('秒')
          }
          if(this.formateCmdParamObj[20]) {
            this.formateCmdParamObj[20] = this.$t(this.fkOpenCloseCodeObj[this.formateCmdParamObj[20]])
          }
          if(this.formateCmdParamObj[19]) {
            this.formateCmdParamObj[19] = this.$t(this.fkFeeCtrlObj[this.formateCmdParamObj[19]])
          }
          if(this.formateCmdParamObj[18]) {
            this.formateCmdParamObj[18] = this.formateCmdParamObj[18] == 1?this.$t('间隔累计正流量和间隔累计逆流量'): this.$t('间隔累计流量')
          }
          if(this.formateCmdParamObj[17]) {
            this.formateCmdParamObj[17] = this.formateCmdParamObj[17] == 255?this.$t('不启用'): this.formateCmdParamObj[17]+this.$t('分钟')
          }
          if(this.formateCmdParamObj[16]) {
            this.formateCmdParamObj[16] = this.formateCmdParamObj[16] == 1?this.$t('采样间隔正流量和逆流量'): this.$t('密集采集流量')
          }
          if(this.formateCmdParamObj[13]) {
            let arr = this.formateCmdParamObj[13].split(',')
            this.formateCmdParamObj[13] = arr[0]/100+'V,'+arr[1]/100+'V'
          }
          if(this.formateCmdParamObj[14]) {
            let arr = this.formateCmdParamObj[14].split(',')
            this.formateCmdParamObj[14] = this.$t('起始时间: ')+arr[0]+this.$t(',结束时间:')+arr[1]+this.$t(',时间间隔: ')+arr[2]+this.$t('分钟')
          }
          if(this.formateCmdParamObj[13]) {
            let arr = this.formateCmdParamObj[13].split(',')
            this.formateCmdParamObj[13] = this.$t('告警阈值1: ')+arr[0]/100+this.$t('V,告警阈值2:')+arr[1]/100+'V'
          }
          if(this.formateCmdParamObj[10]) {
            this.formateCmdParamObj[10] = this.formateCmdParamObj[10]+this.$t('秒')
          }
          if(this.formateCmdParamObj[8]) {
            let arr = this.formateCmdParamObj[8].split(',')
            this.formateCmdParamObj[8] = arr[1]+''+this.$t(this.unitCodeObj[arr[0]])
          }
          if(this.formateCmdParamObj[7]) {
            let arr = this.formateCmdParamObj[7].split(',')
            this.formateCmdParamObj[7] = this.$t('起始时间: ')+arr[0]+this.$t(',结束时间:')+arr[1]+this.$t(',错峰间隔: ')+arr[2]+this.$t('秒')
          }
          if(this.formateCmdParamObj[5]) {
            let arr = this.formateCmdParamObj[5].split(',')
            this.formateCmdParamObj[5] = this.$t('IP地址: ')+arr[0]+this.$t(',端口号:')+arr[1]
          }
          if(this.formateCmdParamObj[3]) {
            this.formateCmdParamObj[3] = this.formateCmdParamObj[3]+this.$t('分钟')
          }
          if(this.formateCmdParamObj[2]) {
            this.formateCmdParamObj[2] = this.formateCmdParamObj[2]+'L/h'
          }
          if(this.formateCmdParamObj[1]) {
            this.formateCmdParamObj[1] = this.formateCmdParamObj[1]+this.$t('分钟')
          }
          if(this.formateCmdParamObj[0]) {
            this.formateCmdParamObj[0] = this.formateCmdParamObj[0]+'L/h'
          }
        }else{
          if(this.model.cmdParam&&this.model.cmdParam!='') {
            this.formateCmdParamObj = JSON.parse(this.model.cmdParam)
          }
        }
      },
      close () {
        this.$emit('close');
        this.model = this.$options.data.call(this).model
        this.formateRemarkObj = this.$options.data.call(this).formateRemarkObj
        this.formateCmdParamObj = this.$options.data.call(this).formateCmdParamObj
        this.visible = false;
      },
      formateRemark(data) {
         // 格式化remark的值显示为列表格式
        let remark = JSON.parse(data)
        console.log(remark)
        if(!remark) {
          return
        }
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
.ant-form-item{
  margin-bottom: 10px;
}
.descriptions /deep/ .ant-descriptions .ant-descriptions-item-label{
  background-color: unset;
  color: rgba(24,144,255,0.85);
}
</style>